/** Wat een adresblok zegt; elk adres dat wordt opgezocht vult dit in. */
export interface AddressLookupCopy {
    postcode: string;
    houseNumber: string;
    suffix: string;
    street: string;
    city: string;
    /** Onder de velden, zolang postcode of huisnummer nog niet compleet is. */
    hint: string;
    /** Onder de velden als de postcode geen Nederlandse kan zijn. */
    abroad: string;
    searching: string;
    choose: (count: number) => string;
    suffixUnknown: (suffix: string) => string;
    choices: string;
    found: string;
    other: string;
    notFound: string;
    unavailable: string;
    manual: string;
    retry: string;
    typeManually: string;
    backToChoices: string;
    enteringManually: string;
    lookUp: string;
}

/**
 * De teksten van een adres opzoeken in de BAG. Het object van een keuring en het
 * adres van een klant zeggen hetzelfde; alleen de hint en de keuzevraag gaan
 * over het eigen adres.
 */
export const addressLookupCopy = {
    postcode: 'Postcode',
    houseNumber: 'Huisnummer',
    suffix: 'Toevoeging',
    street: 'Straat',
    city: 'Plaats',
    searching: 'Adres zoeken…',
    suffixUnknown: (suffix: string) =>
        `Toevoeging ${suffix} staat bij dit huisnummer niet in de BAG. Kies het adres, of vul het zelf in.`,
    choices: 'Adressen op dit huisnummer',
    found: 'Gevonden in de BAG',
    other: 'Ander adres',
    notFound: 'Dit adres staat niet in de BAG. Vul straat en plaats zelf in.',
    unavailable:
        'De BAG is nu niet bereikbaar. Vul straat en plaats zelf in, of zoek het adres zo opnieuw op.',
    manual: 'Vul straat en plaats zelf in.',
    retry: 'Opnieuw zoeken',
    typeManually: 'Zelf invullen',
    abroad: 'Ligt het adres niet in Nederland? Vul het dan zelf in.',
    backToChoices: 'Terug naar de adressen',
    enteringManually:
        'Je vult het adres zelf in, zonder de BAG. Zo kan ook een adres in het buitenland.',
    lookUp: 'Adres opzoeken',
} satisfies Omit<AddressLookupCopy, 'hint' | 'choose'>;

/** Het adres van de klant zelf: uit de BAG komen alleen straat en plaats. */
export const clientAddressCopy: AddressLookupCopy = {
    ...addressLookupCopy,
    hint: 'Straat en plaats komen uit de BAG zodra postcode en huisnummer er staan.',
    choose: (count) => `Op dit huisnummer staan ${count} adressen. Kies het adres van de klant.`,
};
